import React from "react";
import styles from "./errorboundary.module.scss";
import { Misuse } from "@carbon/icons-react";
import { Translation } from "react-i18next";

function ErrorMessage({ heading = "", message = "" }) {
  return (
    <div className={styles.container}>
      <Misuse />
      <div>
        <Translation>{(t) => <h3>{heading}</h3>}</Translation>

        <p>{message}</p>
      </div>
    </div>
  );
}
export default React.memo(ErrorMessage);
